import { __rest } from "tslib";
import Button from 'antd/lib/button';
import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { connectField, filterDOMProps } from 'uniforms';

var ListAdd = function ListAdd(_a) {
  var disabled = _a.disabled,
      parent = _a.parent,
      value = _a.value,
      props = __rest(_a, ["disabled", "parent", "value"]);

  var limitNotReached = !disabled && !(parent.maxCount <= parent.value.length);
  return React.createElement(Button, Object.assign({
    disabled: !limitNotReached || disabled,
    onClick: function onClick() {
      return limitNotReached && parent.onChange(parent.value.concat([cloneDeep(value)]));
    }
  }, filterDOMProps(props)));
};

ListAdd.defaultProps = {
  icon: 'plus-square-o',
  size: 'small',
  style: {
    width: '100%'
  },
  type: 'dashed'
};
export default connectField(ListAdd, {
  includeParent: true,
  initialValue: false
});